import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { ClienteCentralCompraModule } from '../../pessoa/cliente/central-compra';

import { ClienteAnaliseMercadoHeaderComponent } from './cliente-analise-mercado-header.component';

@NgModule({
    imports: [
        SharedModule,
        ClienteCentralCompraModule
    ],
    declarations: [
        ClienteAnaliseMercadoHeaderComponent
    ],
    exports: [
        ClienteAnaliseMercadoHeaderComponent
    ]
})
export class ClienteAnaliseMercadoHeaderModule { }
